import React from 'react'
import Calendar from 'react-calendar';
import { useSelector } from 'react-redux';
import { SaleRegister } from '../../../../assets/icons'
import { Translate } from '../../../../language'
import Input from '../../../../utils/components/Input/Input'
import TitleSVG from '../../../../utils/components/TitleSVG/TitleSVG'
import useModal from '../../../../utils/hooks/useModal'
import style from './Utility.module.css'
const Utility = ({
  dateStart,
  setDateStart,
  dateEnd,
  setDateEnd
}) => {
  const [refStart, isShowStart, setIsShowStart] = useModal(false)
  const [refEnd, isShowEnd, setIsShowEnd] = useModal(false)
  const { utility } = useSelector(state => state.inventory)
  return (
    <div>
      <TitleSVG Icon={SaleRegister} titleHighlight={Translate('inventorySaleUtility', 'es').split(" ")[0]} title={" "+Translate('inventorySaleUtility', 'es').split(/ (.*)/s,2)[1]  } />
      <div>
        <div>
          <div>
            <strong>Total vendido</strong> {utility.utilityProductSubsales}
          </div>
          <div>
            <strong>Total de costo</strong> {utility.totalPriceProductCosts}
          </div>
          <div>
            <strong>Utilidad</strong> {utility.utilityProductSubsales}
          </div>
        </div>
        <div className={style.dates_container}>
          <Input placeholder='Fecha inicial'
            readOnly
            value={dateStart.toLocaleDateString()}
            onClick={() => setIsShowStart(true)}
          />
          <div ref={refStart} >
            {isShowStart &&
              <div

                style={{
                  display: isShowStart ? 'block' : 'none'
                }}
                className="modal calendar-register" >
                <Calendar
                  maxDate={dateEnd}
                  onChange={(dateTime) => {
                    setDateStart(new Date(dateTime))
                    setIsShowStart(false)
                  }
                  }
                />
              </div>
            }
          </div>

          <Input placeholder='Fecha final'
            readOnly
            value={dateEnd.toLocaleDateString()}
            onClick={() => setIsShowEnd(true)}
          />
          <div ref={refEnd} >
            {isShowEnd &&
              <div

                style={{
                  display: isShowEnd ? 'block' : 'none'
                }}
                className="modal calendar-register" >
                <Calendar
                  minDate={dateStart}
                  maxDate={new Date()}
                  onChange={(dateTime) => {
                    setDateEnd(new Date(dateTime))
                    setIsShowEnd(false)
                  }
                  }
                />
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Utility